import { useMatches } from "react-router";
import type { HelpTopicKey } from "src/helpers/helpRouteCatalog";
import type { HelpRouteHandle } from "src/routes/types";

export function getRouteHelp(matches: readonly { handle?: unknown }[]): HelpTopicKey | null {
    for (let i = matches.length - 1; i >= 0; i--) {
        const handle = matches[i].handle as HelpRouteHandle | undefined;
        if (handle && Object.prototype.hasOwnProperty.call(handle, "help")) return handle.help?.topicKey ?? null;
    }
    return null;
}
export default function useRouteHelp(): HelpTopicKey | null {
    return getRouteHelp(useMatches());
}
